import { IGetSuggestResponse } from '../repositories/newbuilding-promos/v1/get-suggest';
import { ESuggestionType, ISuggestionItem } from '../types/suggestions';

export const prepareSuggestions = (response: IGetSuggestResponse): ISuggestionItem[] => {
  const suggestions = response.suggestions;

  return suggestions.map(suggestion => {
    return {
      ...suggestion,
      type: suggestion.type as unknown as ESuggestionType,
    };
  });
};
